import axios from "axios";
import { decryptDataResponse, encryptDataRequest } from "shared/encryptInfo";

// default
axios.defaults.baseURL = "";

// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// interceptando solicitudes para cifrar datos
axios.interceptors.request.use(
  (config: any) => {
    if (config.data) {
      const encryptedData = encryptDataRequest(config.data);
      config.data = { data: encryptedData };
    }

    // 🔐 Agregar apiKey a todas las solicitudes
    config.headers = {
      ...config.headers,
      key: "gzlq#A50Y8mc&6ylpO9jgiL6@UxdkkBy",
    };

    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

// interceptando respuestas para descifrar datos
axios.interceptors.response.use(
  (response: any) => {
    if (response.data?.statusCode === 200 && response.data?.data) {
      // console.log("INTERCEPTOR", response.data);
      try {
        const decrypted = decryptDataResponse({ data: response.data.data });
        // Reemplaza solo el campo `data` con el contenido desencriptado
        // console.log("Interceptor Desencriptado:", decrypted);
        response.data.data = decrypted;
      } catch (err) {
        console.error("Error al desencriptar:", err);
        // Puedes retornar el response sin modificar si prefieres no romper
      }
    }

    return response.data;
  },
  (error: any) => {
    // Manejo de errores con decrypt, si `data` también está dentro de error.response
    let message: any = "Ocurrió un error";
    try {
      const errorResponse = error?.response?.data;
      const decryptedErrorData =
        errorResponse?.data && typeof errorResponse.data === "string"
          ? decryptDataResponse({ data: errorResponse.data })
          : null;
      console.log(error);
      switch (error.response?.status) {
        case 400:
          message = error?.response?.data || "Error de solicitud";
          break;
        case 401:
          message = error?.response?.data || "Credenciales inválidas";
          break;
        case 404:
          message =
            error?.response?.data || "No se encontró el recurso solicitado";
          break;
        case 500:
          message = error?.response?.data || "Error interno del servidor";
          break;
        default:
          message = error?.response?.data || "Error desconocido";
      }
    } catch (err) {
      console.error("Error al manejar la respuesta de error:", err);
    }

    return Promise.reject(message);
  }
);

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = async (token: any) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from given url
   */
  get = async (url: string, params: Record<string, any> | null) => {
    let queryString = "";

    if (params) {
      const paramKeys: string[] = [];
      Object.keys(params).forEach((key) => {
        if (params[key] !== undefined && params[key] !== null) {
          paramKeys.push(
            `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
          );
        }
      });

      if (paramKeys.length > 0) {
        queryString = `?${paramKeys.join("&")}`;
      }
    }

    try {
      const response = await axios.get(`${url}${queryString}`);
      return response;
    } catch (error) {
      console.error("Error in GET request:", error);
      throw error;
    }
  };
  /**
   * post given data to url
   */
  create = (url: any, data: any) => {
    return axios.post(url, data);
  };
  /**
   * post given data to url
   */
  post = (url: any, data: any) => {
    return axios.post(url, data);
  };
  /**
   * Updates data
   */
  update = (url: any, data: any) => {
    return axios.patch(url, data);
  };

  put = (url: any, data: any) => {
    return axios.put(url, data);
  };
  patch = (url: any, data: any, config?: any) => {
    return axios.patch(url, data, config);
  };
  /**
   * Delete
   */
  delete = (url: any, config: any) => {
    return axios.delete(url, { ...config });
  };

  /**
   * Patch
   */
}

const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };
